export const origin = window.location;
export const isTripord = window?.location?.origin?.includes?.('tripord') || false;
